import React, { useEffect, useState } from "react";
import {
  Typography,
  Row,
  Col,
  Breadcrumb,
  Space,
  Button,
  Dropdown,
  message,
  Card,
  Input,
  Collapse,
  Checkbox,
  Divider,
  Pagination,
  Select,
  Image,
} from "antd";
import { AppFooter } from "../LandingPage/Components/Footer/Footer";
import LogoGallery from "../LandingPage/Components/Logo/Logos";
import { useNotification } from "~/Hooks/useNotification";
import type { MenuProps } from "antd";
import Infra from "@assets/KPMG/infra.png";
import {
  HomeOutlined,
  DownOutlined,
  PlusOutlined,
  MinusOutlined,
} from "@ant-design/icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import styles from "./InfratechMarketplace.module.scss";
import MainHeader from "../../Components/MainHeader/MainHeader";
import { TabInfo } from "../LandingPage/Components/MarketPlace/TabInfo";
import {
  mockData,
  mockDataMultiple,
} from "../LandingPage/Components/MarketPlace/mock";
import MarketingCard from "~/Components/MarketingCard/MarketingCard";

import { NoData } from "./Components/NoData";

const { Search } = Input;
const { Panel } = Collapse;

export const InfratechMarketPlaceList: React.FC = () => {
  const { openToast } = useNotification();
  const [searchParams, setSearchParams] = useSearchParams();
  const typeParam = searchParams.get("type");
  const [data, setData] = useState<any>({ projectList: [] });
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(8);
  const [providerData, setProviderData] = useState<any>([]);
  const [selectData, setSelectData] = useState("");
  const totalItems = data.projectList?.length;
  const [filterData, setFilterData] = useState<any>({
    solutionAndType: [],
    provider: [],
  });
  const navigate = useNavigate();

  const updateFilter = (
    fieldName: string,
    itemName: string,
    value: any,
    solutionName = ""
  ) => {
    let filterValues = { ...filterData };
    if (fieldName === "provider") {
      if (value) {
        filterValues.provider.push(itemName);
      } else {
        let temp = [...filterValues.provider];
        let index = temp.findIndex((item: any) => item === itemName);
        if (index > -1) {
          temp.splice(index, 1);
        }
        filterValues.provider = temp;
      }
    } else if (fieldName === "solution") {
      if (value) {
        filterValues.solutionAndType.push({
          fieldName,
          itemName,
          solutionName,
        });
      } else {
        let temp = [...filterValues.solutionAndType];
        let index = temp.findIndex(
          (item: any) =>
            item.solutionName === solutionName && item.itemName === itemName
        );
        if (index > -1) {
          temp.splice(index, 1);
        }
        filterValues.solutionAndType = temp;
      }
    }
    console.log("filter values", filterValues);
    setFilterData(filterValues);
    let tempData: any = [...mockDataMultiple.projectList];
    let arr: any = [];
    let provider = filterValues.provider;
    if (provider.length > 0) {
      arr = tempData.filter((record: any) =>
        provider.includes(record.provider)
      );
    } else {
      arr = [...tempData];
    }

    let newArr: any = [];
    let solutionAndType = filterValues.solutionAndType;
    if (solutionAndType.length > 0) {
      arr.map((record: any) => {
        let isValid = false;
        for (let item of solutionAndType) {
          if (
            item.solutionName === record.solution &&
            item.itemName === record.type
          ) {
            isValid = true;
            newArr.push(record);
            break;
          }
        }
      });
      arr = [...newArr];
    }
    setData({ ...data, projectList: arr });
  };

  const solutionFilter = [
    {
      title: "Smart Building Solutions",
      items: [
        {
          title: "Package Solutions",
          // count: mockDataMultiple.projectList.filter(
          //   (item: any) =>
          //     item.solution === "Smart Building Solutions" &&
          //     item.type === "Package Solutions"
          // ),
        },
        {
          title: "Services",
        },
        {
          title: "Technologies",
        },
      ],
    },
    {
      title: "Solar Panel Solutions",
      items: [
        {
          title: "Package Solutions",
        },
        {
          title: "Services",
        },
        {
          title: "Technologies",
        },
      ],
    },
    {
      title: "EV Solutions",
      items: [
        {
          title: "Package Solutions",
        },
        {
          title: "Services",
        },
        {
          title: "Technologies",
        },
      ],
    },
  ];
  useEffect(() => {
    let provider: any = [];
    mockDataMultiple.projectList.map((item: any) => {
      if (!provider.includes(item.provider)) {
        if (item.provider) {
          provider.push(item.provider);
        }
      }
    });
    setProviderData(provider);
    if (typeParam && typeParam === "Services") {
      let newRecords = [...mockDataMultiple.projectList];
      newRecords = newRecords.filter((item: any) => item.type === "Services");
      let newData = { ...mockDataMultiple, projectList: newRecords };
      setData(newData);
      setFilterData({
        solutionAndType: [
          {
            fieldName: "solution",
            itemName: "Services",
            solutionName: "Smart Building Solutions",
          },
          {
            fieldName: "solution",
            itemName: "Services",
            solutionName: "Solar Panel Solutions",
          },
          {
            fieldName: "solution",
            itemName: "Services",
            solutionName: "EV Solutions",
          },
        ],
        provider: [],
      });
    } else {
      getRecords();
    }
  }, []);

  const handlePageChange = (page: number, pageSize?: number) => {
    setCurrentPage(page);
    setPageSize(pageSize || 8);
  };

  const getRecords = async () => {
    setData(mockDataMultiple);
  };

  const leadingBanks = (
    <Typography.Title level={5}>Leading Banks</Typography.Title>
  );

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    console.log("click", e);
  };

  const items: MenuProps["items"] = [
    {
      label: "Product",
      key: "11",
    },
    {
      label: "Provider",
      key: "12",
    },
    {
      label: "Solution",
      key: "13",
    },
    {
      label: "Type",
      key: "14",
    },
  ];

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const onSearch = (value: string) => console.log(value);

  const panelStyle = {
    marginBottom: 24,
    border: "none",
  };

  return (
    <>
      <MainHeader
        title="INFRATECH MARKETPLACE"
        imageSrc={Infra}
        text={
          "Transform your buildings into smarter and greener by bringing seamless connectivity from floor to floor. Harness the power of data collection to unlock valuable insights that will propel the business forward."
        }
      />
      <div style={{ background: "#fff" }}>
        <Row justify="center">
          <Col lg={2}></Col>
          <Col lg={20} style={{ marginTop: "1.5rem" }}>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Icon
                  icon="ic:outline-home"
                  height="20"
                  onClick={() => navigate("/")}
                  style={{
                    margin: "auto",
                    color: styles.strawberry,
                    cursor: "pointer",
                  }}
                />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <a onClick={() => navigate("/infratech-marketplace")}>
                  Infratech Marketplace
                </a>
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col lg={2}></Col>
        </Row>
        <Row>
          <Col lg={2}></Col>
          <Col lg={20} style={{ paddingTop: 20 }}>
            <Row gutter={16}>
              <Col lg={6}>
                <div className="listview-input">
                  <Input
                    placeholder="Search"
                    style={{
                      width: "100%",
                      borderRadius: "0.5rem",
                      marginBottom: 20,
                    }}
                  />
                  <div>
                    <Collapse
                      bordered={false}
                      defaultActiveKey={["1", "2", "3", "4"]}
                      expandIcon={({ isActive }) =>
                        isActive ? <MinusOutlined /> : <PlusOutlined />
                      }
                      expandIconPosition="end"
                      style={{ background: "#fff" }}
                    >
                      {solutionFilter.map((solution: any, sIndex: number) => (
                        <>
                          <Panel
                            header={solution.title}
                            key={`${sIndex + 1}`}
                            className="text"
                            style={panelStyle}
                          >
                            <div>
                              {solution.items.map(
                                (item: any, index: number) => {
                                  let foundIndex =
                                    filterData.solutionAndType.findIndex(
                                      (temp: any) =>
                                        temp.solutionName === solution.title &&
                                        temp.itemName === item.title
                                    );
                                  return (
                                    <>
                                      <Checkbox
                                        key={`${sIndex}-solution-${index}`}
                                        onChange={(e) => {
                                          updateFilter(
                                            "solution",
                                            item.title,
                                            e.target.checked,
                                            solution.title
                                          );
                                        }}
                                        checked={foundIndex > -1}
                                      >
                                        {item.title}
                                      </Checkbox>
                                      <br />
                                    </>
                                  );
                                }
                              )}
                            </div>
                          </Panel>
                          <Divider key={`${sIndex + 1}`} />
                        </>
                      ))}
                      <Panel
                        header="Provider"
                        className="text"
                        key="4"
                        style={panelStyle}
                      >
                        <div>
                          {providerData.map((item: string, index: number) => (
                            <>
                              <Checkbox
                                key={`provider-${index}`}
                                onChange={(e) =>
                                  updateFilter(
                                    "provider",
                                    item,
                                    e.target.checked
                                  )
                                }
                              >
                                {item}
                              </Checkbox>
                              <br />
                            </>
                          ))}
                        </div>
                      </Panel>
                    </Collapse>
                  </div>
                </div>
              </Col>
              <Col lg={18}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 20,
                  }}
                >
                  <Typography.Title level={4}>Products</Typography.Title>
                  {/* <Space className="invest-sort-button">
                    Sort By
                    <Dropdown menu={menuProps}>
                      <Button>
                        <Space>
                          Location &nbsp;&nbsp;
                          <DownOutlined />
                        </Space>
                      </Button>
                    </Dropdown>
                  </Space> */}
                </div>
                {data && data.projectList.length === 0 && (
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <NoData />
                    </Col>
                  </Row>
                )}
                {data && data.projectList && data.projectList.length > 0 && (
                  <Row gutter={[16, 16]}>
                    {/* <Col span={24}>
                    <BuildingProjects />
                  </Col> */}
                    {data &&
                      data.projectList &&
                      data.projectList
                        .slice(
                          (currentPage - 1) * pageSize,
                          currentPage * pageSize
                        )
                        .map((item: any, index: number) => (
                          <Col lg={12} style={{ marginTop: "0.9rem" }}>
                            <MarketingCard item={item} index={index} />
                          </Col>
                        ))}
                    <Col
                      lg={24}
                      className="invest-sort"
                      style={{ marginTop: 10 }}
                    >
                      <Row justify="space-between">
                        <Col className="first-col">
                          {/* <Space>
                            <Typography.Text>sort</Typography.Text>
                            <Select
                              defaultValue="1"
                              style={{ width: 50 }}
                              onChange={(e) => setSelectData(e)}
                              options={[
                                { value: "1", label: "1" },
                                { value: "2", label: "2" },
                                { value: "3", label: "3" },
                              ]}
                            />
                            <Typography.Text>Products per Page</Typography.Text>
                          </Space> */}
                        </Col>
                        <Col>
                          <Pagination
                            current={currentPage}
                            pageSize={pageSize}
                            total={totalItems}
                            onChange={handlePageChange}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </Col>
          <Col lg={2}></Col>
        </Row>
      </div>
      <LogoGallery element={leadingBanks} />
      <AppFooter />
    </>
  );
};
